<template>

  <div v-html="HtmlString"></div>

</template>

<script>
export default {
  props: {
    // Legenda - základní seznam složek
    HtmlString: null,
  },
};
</script>

<style>
MlPanel {
  font: normal 1em/1.5em "Arial CE", "Helvetica CE", Arial, Helvetica,
    sans-serif;
  color: #ffffff;
  margin: 0.1875em;
  overflow-wrap: normal;
}

.MlNadpis_01 {
  font-size: 1em;
  margin: 0.5em;
}

/* Tabulka 01 - tři sloupce, první pro img nebo červený text, druhý žlutý text, třetí bílý text  */
.MlTab_01 {
  font-size: 0.875em;
}

/* první sloupec */
.MlTab_01 td:nth-child(3n + 1) {
  color: red;
}

/* první sloupec - img */
.MlTab_01 td:nth-child(3n + 1) img {
  width: 2.5em;
  height: 2.5em;
  background-color: white;
}

.MlTab_01 td:nth-child(3n + 1) img:hover {
  transform: scale(2, 2);
  transform-origin: 0%;
}

/* druhý sloupec */
.MlTab_01 td:nth-child(3n + 2) {
  color: rgb(255, 193, 7);
  min-width: 3em;
  text-align: center;
}

/* třetí sloupec */
.MlTab_01 td:nth-child(3n + 3) {
  color: white;
}

/* Tabulka 02 - třetí sloupec žlutý text, čtvrtý bílý text */
.MlTab_02 {
  font-size: 0.875em;
}

/* třetí sloupec */
.MlTab_02 td:nth-child(3n + 3) {
  color: rgb(255, 193, 7);
  padding-left: 10px;
}

/* čtrvtý sloupec */
.MlTab_02 td:nth-child(3n + 4) {
  color: white;
}

/* první řádek - vycentrovaný tlustý zelený text*/
.MlTab_02 tr:first-child td {
  text-align: center;
  color: forestgreen;
  font-weight: bold;
}

/* Tabulka 03 - druhý sloupec žlutý text, třetí bílý text */
.MlTab_03 {
  font-size: 0.875em;
}

/* druhý sloupec */
.MlTab_03 td:nth-child(3n + 2) {
  color: rgb(255, 193, 7);
  padding-left: 10px;
}

/* třetí sloupec */
.MlTab_03 td:nth-child(3n + 3) {
  color: white;
}

/* první řádek - vycentrovaný tlustý zelený text*/
.MlTab_03 tr:first-child td {
  text-align: center;
  color: forestgreen;
  font-weight: bold;
}

/* Tabulka 04 - druhý sloupec žlutý text, třetí bílý text, bez zvýrazněného prvního řádku */
.MlTab_04 {
  font-size: 0.875em;
}

/* druhý sloupec */
.MlTab_04 td:nth-child(3n + 2) {
  color: rgb(255, 193, 7);
  padding-left: 10px;
}

/* třetí sloupec */
.MlTab_04 td:nth-child(3n + 3) {
  color: white;
}


/* (16px-1em) */
/*  */
.MlFs16 {
  font-size: 1em;
}

/* (14px-0.875em) */
/* Základ - skoro všechno */
.MlFs14 {
  font-size: 0.875em;
}

/* (12px-0.75em) */
/*  */
.MlFs12 {
  font-size: 0.75em;
}

/* (10px-0.625em) */
/* Copyright */
.MlFs10 {
  font-size: 0.625em;
}

/* Zvýraněný text - tlustý a zelený */
.MlFzv_1 {
  color: forestgreen;
  font-weight: bold;
}

.MlImg_1 {
  width: 2em;
  height: 2em;
}

/* čtverec */
.MlSqr_1 {
  width: 2.5em;
  height: 2.5em;
  border: 4px solid black;
}

/* čtverec vycentrovaný*/
.MlSqr_2 {
  width: 2.5em;
  height: 2.5em;
  border: 4px solid black;
  margin: auto;
}

/* linie */
.MlLin_1 {
  margin: 0.25em;
  /* height: 0.5em; */
  /* border-width: 0; */
  border-radius: 0.25em;
}

td:has(> .MlLin_1) {
  height: 2.5em;
  width: 5em;
  background-color: white;
}




.MlVaT {
  vertical-align: top;
}

.MlVaB {
  vertical-align: bottom;
}

.MlMoB_01 {
  position: relative;
  top: 1.25em;
}

/* obrázek v legendě bhist*/
.MlImg_Bhist {
  width: 100%;
  max-width: 300px;
}

/* div s obrázkem v legendě bhist*/
div:has(> img.MlImg_Bhist) {
  width: fit-content;
  background-color: white;
  padding: 5px;
  margin-top: 15px;
}

/* obrázek v legendě opr2*/
.MlImg_Opr2 {
  width: 100%;
  max-width: 300px;
}

/* div s obrázkem v legendě bhist*/
div:has(> img.MlImg_Opr2) {
  width: fit-content;
  /* background-color: white; */
  padding: 5px;
  margin-top: 15px;
}


</style>